import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isExportDataRequestFailure() {
      return getState().isFailure;
    },
    isExportDataRequestPending() {
      return getState().isPending;
    },
    isExportDataRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
